import Vue from 'vue';
import axios from 'axios';
import Clipboard from 'clipboard';
import Toast, { TYPE }  from "vue-toastification";
import Vuelidate from 'vuelidate';
import VueChartJs from 'vue-chartjs'
import VueConfetti from 'vue-confetti'
Vue.use(VueConfetti)

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import "vue-toastification/dist/index.css";
import 'epic-spinners/dist/lib/epic-spinners.min.css'

import InnerHtnlToastV5 from './components/dashboard-v5/toast/InnerHtnlToastV5.vue'

import InfiniteLoading from 'vue-infinite-loading';

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)




window.Vue = Vue;
window.axios = axios;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const templateCopy = (copiedText) => (`
<div class="copied__clipboard"
  style="position:absolute;
        left:0;
        right:0;
        margin:0 auto;
        top:-23px;
        background-color:white;
        border-radius:6px;
        border: 1px solid #1278c3;
        width:100px;
        padding: 0 .4rem;
        color: black;
        opacity: 0.6;
        z-index:999;">
  ${copiedText}
  </div>
`)
var clipboard = new Clipboard('.copy');

clipboard.on('success', function(e) {
  //se tiver data-labelCopy="" no campo para copiar ira aparecer um tooltip de copiado
  if(e.trigger.dataset.labelcopy) {
    $(e.trigger).css('position', 'relative');
    $(e.trigger).append(templateCopy(e.trigger.dataset.labelcopy));
  }
  setTimeout(() => {
    $('.copied__clipboard').remove();
  }, 500);
});

const templateCopyV2 = (copiedText) => (`
<div class="copied__clipboard"
  style="position:absolute;
        left:0;
        right:0;
        margin:0 auto;
        bottom: -32px;
        display: flex;
        align-items: center;
        padding: 0 1rem;
        background-color: #5B5B5B;
        border-radius: 4px 4px 0 0 ;
        width:100px;
        height: 35px;
        color: white;
        z-index:999;">
  ${copiedText}
  </div>
`)
var clipboard_v2 = new Clipboard('.copy__v2');
clipboard_v2.on('success', function(e) {
  // console.log($(e.trigger.dataset.clipboardTarget));
  if(e.trigger.dataset.labelcopy) {
    $(e.trigger.dataset.clipboardTarget).parent().css('position', 'relative');
    $(e.trigger.dataset.clipboardTarget).parent().append(templateCopyV2(e.trigger.dataset.labelcopy));
  }
  setTimeout(() => {
    $('.copied__clipboard').remove();
  }, 500);
});

Vue.directive('wheel', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('wheel', f)
      }
    }
    window.addEventListener('wheel', f)
  }
})

//border radius on bar chart for chartjs v2
Chart.elements.Rectangle.prototype.draw = function() {
  var ctx = this._chart.ctx;
  var vm = this._view;
  var left, right, top, bottom, signX, signY, borderSkipped, radius;
  var borderWidth = vm.borderWidth;

  // If radius is less than 0 or is large enough to cause drawing errors a max
  //      radius is imposed. If cornerRadius is not defined set it to 0.
  var cornerRadius = this._chart.config.options.cornerRadius;
  var fullCornerRadius = this._chart.config.options.fullCornerRadius;
  var stackedRounded = this._chart.config.options.stackedRounded;
  var typeOfChart = this._chart.config.type;

  if (cornerRadius < 0) {
    cornerRadius = 0;
  }
  if (typeof cornerRadius == 'undefined') {
    cornerRadius = 0;
  }
  if (typeof fullCornerRadius == 'undefined') {
    fullCornerRadius = false;
  }
  if (typeof stackedRounded == 'undefined') {
    stackedRounded = false;
  }

  if (!vm.horizontal) {
    // bar
    left = vm.x - vm.width / 2;
    right = vm.x + vm.width / 2;
    top = vm.y;
    bottom = vm.base;
    signX = 1;
    signY = bottom > top ? 1 : -1;
    borderSkipped = vm.borderSkipped || 'bottom';
  } else {
    // horizontal bar
    left = vm.base;
    right = vm.x;
    top = vm.y - vm.height / 2;
    bottom = vm.y + vm.height / 2;
    signX = right > left ? 1 : -1;
    signY = 1;
    borderSkipped = vm.borderSkipped || 'left';
  }

  // Canvas doesn't allow us to stroke inside the width so we can
  // adjust the sizes to fit if we're setting a stroke on the line
  if (borderWidth) {
    // borderWidth shold be less than bar width and bar height.
    var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
    borderWidth = borderWidth > barSize ? barSize : borderWidth;
    var halfStroke = borderWidth / 2;
    // Adjust borderWidth when bar top position is near vm.base(zero).
    var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
    var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
    var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
    var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
    // not become a vertical line?
    if (borderLeft !== borderRight) {
      top = borderTop;
      bottom = borderBottom;
    }
    // not become a horizontal line?
    if (borderTop !== borderBottom) {
      left = borderLeft;
      right = borderRight;
    }
  }

  ctx.beginPath();
  ctx.fillStyle = vm.backgroundColor;
  ctx.strokeStyle = vm.borderColor;
  ctx.lineWidth = borderWidth;

  // Corner points, from bottom-left to bottom-right clockwise
  // | 1 2 |
  // | 0 3 |
  var corners = [
    [left, bottom],
    [left, top],
    [right, top],
    [right, bottom]
  ];

  // Find first (starting) corner with fallback to 'bottom'
  var borders = ['bottom', 'left', 'top', 'right'];
  var startCorner = borders.indexOf(borderSkipped, 0);
  if (startCorner === -1) {
    startCorner = 0;
  }

  function cornerAt(index) {
    return corners[(startCorner + index) % 4];
  }

  // Draw rectangle from 'startCorner'
  var corner = cornerAt(0);
  ctx.moveTo(corner[0], corner[1]);


  var nextCornerId, nextCorner, width, height, x, y;
  for (var i = 1; i < 4; i++) {
    corner = cornerAt(i);
    nextCornerId = i + 1;
    if (nextCornerId == 4) {
      nextCornerId = 0
    }

    nextCorner = cornerAt(nextCornerId);

    width = corners[2][0] - corners[1][0];
    height = corners[0][1] - corners[1][1];
    x = corners[1][0];
    y = corners[1][1];

    var radius = cornerRadius;
    // Fix radius being too large
    if (radius > Math.abs(height) / 2) {
      radius = Math.floor(Math.abs(height) / 2);
    }
    if (radius > Math.abs(width) / 2) {
      radius = Math.floor(Math.abs(width) / 2);
    }

      var x_tl, x_tr, y_tl, y_tr, x_bl, x_br, y_bl, y_br;
      if (height < 0) {
        // Negative values in a standard bar chart
        x_tl = x;
        x_tr = x + width;
        y_tl = y + height;
        y_tr = y + height;

        x_bl = x;
        x_br = x + width;
        y_bl = y;
        y_br = y;

        // Draw
        ctx.moveTo(x_bl + radius, y_bl);

        ctx.lineTo(x_br - radius, y_br);

        // bottom right
        ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius);


        ctx.lineTo(x_tr, y_tr + radius);

        // top right
        fullCornerRadius ? ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr) : ctx.lineTo(x_tr, y_tr, x_tr - radius, y_tr);


        ctx.lineTo(x_tl + radius, y_tl);

        // top left
        fullCornerRadius ? ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius) : ctx.lineTo(x_tl, y_tl, x_tl, y_tl + radius);


        ctx.lineTo(x_bl, y_bl - radius);

        //  bottom left
        ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl);

      } else if (width < 0) {
        // Negative values in a horizontal bar chart
        x_tl = x + width;
        x_tr = x;
        y_tl = y;
        y_tr = y;

        x_bl = x + width;
        x_br = x;
        y_bl = y + height;
        y_br = y + height;

        // Draw
        ctx.moveTo(x_bl + radius, y_bl);

        ctx.lineTo(x_br - radius, y_br);

        //  Bottom right corner
        fullCornerRadius ? ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius) : ctx.lineTo(x_br, y_br, x_br, y_br - radius);

        ctx.lineTo(x_tr, y_tr + radius);

        // top right Corner
        fullCornerRadius ? ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr) : ctx.lineTo(x_tr, y_tr, x_tr - radius, y_tr);

        ctx.lineTo(x_tl + radius, y_tl);

        // top left corner
        ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius);

        ctx.lineTo(x_bl, y_bl - radius);

        //  bttom left corner
        ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl);

      } else {

          var lastVisible = 0;
        for (var findLast = 0, findLastTo = this._chart.data.datasets.length; findLast < findLastTo; findLast++) {
          if (!this._chart.getDatasetMeta(findLast).hidden) {
            lastVisible = findLast;
          }
        }
        var rounded = this._datasetIndex === lastVisible;

        if (rounded) {
        //Positive Value
          ctx.moveTo(x + radius, y);

          ctx.lineTo(x + width - radius, y);

          // top right
          ctx.quadraticCurveTo(x + width, y, x + width, y + radius);


          ctx.lineTo(x + width, y + height - radius);

          // bottom right
          if (fullCornerRadius || typeOfChart == 'horizontalBar')
            ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
          else
            ctx.lineTo(x + width, y + height, x + width - radius, y + height);


          ctx.lineTo(x + radius, y + height);

          // bottom left
          if (fullCornerRadius)
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
          else
            ctx.lineTo(x, y + height, x, y + height - radius);


          ctx.lineTo(x, y + radius);

          // top left
          if (fullCornerRadius || typeOfChart == 'bar')
            ctx.quadraticCurveTo(x, y, x + radius, y);
          else
            ctx.lineTo(x, y, x + radius, y);
        }else {
          ctx.moveTo(x, y);
          ctx.lineTo(x + width, y);
          ctx.lineTo(x + width, y + height);
          ctx.lineTo(x, y + height);
          ctx.lineTo(x, y);
        }
      }

  }

  ctx.fill();
  if (borderWidth) {
    ctx.stroke();
  }
};

// vue-chartjs requires extend
for (let key in VueChartJs) {
    if (!['generateChart', 'mixins', 'render'].includes(key)) {
        let name = `${key.replace( /([A-Z])/g, " $1" ).trim().replace(' ', '-').toLocaleLowerCase()}-chart`

        Vue.component(name, {
            extends: VueChartJs[key],
            name: name,
            mixins: [VueChartJs.mixins.reactiveProp],
            props: [
                'options',
                'width',
                'height',
                'chart-id',
                'css-classes',
                'styles',
                'plugins'
            ],
            mounted() {
                // this.chartData is created in the mixin.
                // If you want to pass options please create a local options object
                this.renderChart(this.chartData, this.options)
            },
            watch: {
              options (oldVal, newVal) {
                if(JSON.stringify(oldVal) != JSON.stringify(newVal)) {
                  this.renderChart(this.chartData, this.options);
                }
              }
            }
        })

    }
}

Vue.config.ignoredElements = [
  'builderall-icon'
];

//components
Vue.component('header-page',            require('./components/franchise/components/header'));
Vue.component('sub-title-header-page',  require('./components/franchise/components/subTitleHeader'));
Vue.component('gains-user',             require('./components/franchise/components/gainsUser'));
Vue.component('graphic-disclosures',    require('./components/franchise/components/graphicDisclosures'));
Vue.component('info-steps',             require('./components/franchise/components/infoSteps'));
Vue.component('links-user',             require('./components/franchise/components/linksUser'));
Vue.component('menus',                  require('./components/franchise/components/menus'));
Vue.component('network-user',           require('./components/franchise/components/networkUser'));
Vue.component('affiliates-show-case',   require('./components/franchise/components/affiliatesShowCase'));
Vue.component('all-values-user',        require('./components/franchise/components/allValuesUser'));
Vue.component('connections-user',       require('./components/franchise/components/connectionsUser'));
Vue.component('countdown-for-user',     require('./components/franchise/components/countdownForUser'));
Vue.component('flip-countdown-ba',      require('./components/franchise/components/countdownClock'));
Vue.component('fast-links',             require('./components/franchise/components/fastLinks'));
Vue.component('invite-leaders',         require('./components/franchise/components/inviteLeaders'));
Vue.component('wizard-steps',           require('./components/franchise/components/wizardSteps'));
Vue.component('info-leads',             require('./components/franchise/components/infoLeads'));
Vue.component('ba-v3-calculator',       require('./components/CalculatorV3'));
Vue.component('office-invoices-new',    require('./components/InvoicesNew'));
Vue.component('ba-form-w8bene',         require('./components/W8BenE'));
Vue.component('domain-connection',      require('./components/DomainConnection'));
Vue.component('sign-document',          require('./components/SignDocument'));
Vue.component('invoices-billing-tab',   require('./components/invoices/BillingTab'));
Vue.component('resources-quotas',       require('./components/resources/ResourcesQuotas'));
Vue.component('card-component',         require('./components/invoices/CardComponent'));

//conta time
Vue.component('team-account-management',  require('./components/team-account/management'));
Vue.component('team-account-user',        require('./components/team-account/user'));
Vue.component('team-account-request',     require('./components/team-account/request'));
Vue.component('team-account-member',      require('./components/team-account/member'));

// Old Dash
Vue.component('dashboard-training',       require('./components/dashboard/training/index'));

// <onboarding-funel>
  Vue.component('office-onboarding-funnel',   require('./components/dashboard/onboardingFunnel/index'));
  Vue.component('of-content-1',               require('./components/dashboard/onboardingFunnel/content-1/index'));
  Vue.component('of-content-2',               require('./components/dashboard/onboardingFunnel/content-2/index'));
  Vue.component('of-content-3',               require('./components/dashboard/onboardingFunnel/content-3/index'));
  Vue.component('of-content-4',               require('./components/dashboard/onboardingFunnel/content-4/index'));
  Vue.component('of-content-5',               require('./components/dashboard/onboardingFunnel/content-5/index'));
  // Vue.component('of-content-6', require('./components/dashboard/onboardingFunnel/content-6/index'));
  Vue.component('of-content-7',               require('./components/dashboard/onboardingFunnel/content-7/index'));
  Vue.component('of-content-10',              require('./components/dashboard/onboardingFunnel/content-10/index'));
// </onboarding-funel>

//virtual assistant
Vue.component('virtual-assistant',        require('./components/virtual-assistant/index'));
Vue.component('tools',                    require('./components/virtual-assistant/tools'));

//emails app
Vue.component('emails-app',               require('./components/emails-app/index'));
Vue.component('create-email',             require('./components/emails-app/create-email'));
Vue.component('emails-list',              require('./components/emails-app/emails-list'));
Vue.component('emails-settings',          require('./components/emails-app/emails-settings'));
Vue.component('emails-settings-alias',    require('./components/emails-app/settings/alias'));
Vue.component('emails-settings-forward',  require('./components/emails-app/settings/forward'));

Vue.component('ba-franchise-modals-v5',               require('./components/franchise_v4/modals/index'));
Vue.component('modal-magic-funnel-v5',                require('./components/franchise_v4/modals/MagicFunnel'));
Vue.component('modal-redirect-link-v5',               require('./components/franchise_v4/modals/RedirectLink'));
Vue.component('modal-telegram-v5',                    require('./components/franchise_v4/modals/Telegram'));
Vue.component('modal-whatsapp-v5',                    require('./components/franchise_v4/modals/Whatsapp'));

//<globals elements>

Vue.component('notification-center',        require('./components/notification/index'));
Vue.component('old-notification-center',    require('./components/notification/OldIndex'));


//domains-storage
Vue.component('buy-extra-connection',         require('./components/domains-storage/buyExtraDomainConnection'));
Vue.component('buy-extra-storage',            require('./components/domains-storage/buyExtraStorage'));
Vue.component('storage-details',              require('./components/domains-storage/storageDetails'));
Vue.component('domain-ns',                    require('./components/domains-storage/domainNS'));
Vue.component('connect-domain-funnels',       require('./components/domains-storage/connectDomainFunnels'));
Vue.component('disconnect-domain-funnels',    require('./components/domains-storage/disconnectDomainFunnels'));

// funnel club
Vue.component('cheetah-funnel-builder-templates',   require('./components/funnel-club/CheetahFunnelBuilderTemplates'));
Vue.component('funnel-club',                        require('./components/funnel-club/FunnelClub'));


//super-checkout-intern
Vue.component('super-checkout-intern',                 require('./components/super-checkout-intern'));
Vue.component('super-checkout-intern-header',          require('./components/super-checkout-intern/header'));
Vue.component('super-checkout-intern-body',            require('./components/super-checkout-intern/body'));
Vue.component('super-checkout-intern-card',            require('./components/super-checkout-intern/card'));
Vue.component('super-checkout-intern-modal',           require('./components/super-checkout-intern/modal'));
Vue.component('super-checkout-intern-modal-firstTab',  require('./components/super-checkout-intern/modal/firstTab'));
Vue.component('super-checkout-intern-modal-secondTab', require('./components/super-checkout-intern/modal/secondTab'));
Vue.component('super-checkout-intern-modal-thirdTab',  require('./components/super-checkout-intern/modal/thirdTab'));


Vue.component('create-token-2fa',  require('./components/token-2fa/create-token'));
Vue.component('handle-token-2fa',  require('./components/token-2fa/handle-token'));

// Pixel Events
Vue.component('pixel-events-settings-modal', require('./components/pixel-events/settingsModal'));

// <ba-v5>
Vue.component('dv5-main',                               require('./components/dashboard-v5'));
Vue.component('dv5-header',                             require('./components/dashboard-v5/header'));
Vue.component('dv5-buy-domain',                         require('./components/dashboard-v5/buy-domain/BuyDomain.vue'));
Vue.component('dv5-my-stuff',                           require('./components/dashboard-v5/my-stuff'));
Vue.component('dv5-start-a-project',                    require('./components/dashboard-v5/start-a-project'));
Vue.component('dv5-tool',                               require('./components/dashboard-v5/tool'));
Vue.component('dv5-tutorial',                           require('./components/dashboard-v5/tutorial'));
Vue.component('dv5-shared-collapse',                    require('./components/dashboard-v5/shared/Collapse.vue'));
Vue.component('dv5-collapse-mobile',                    require('./components/dashboard-v5/shared/CollapseToolsFilter'));
Vue.component('dv5-shared-carousel',                    require('./components/dashboard-v5/shared/Carousel.vue'));
Vue.component('dv5-multiline-slide-grid-h',             require('./components/dashboard-v5/shared/MultilineSlideGridH.vue'));
Vue.component('dv5-shared-carousel-banner',             require('./components/dashboard-v5/shared/CarouselBanner.vue'));
Vue.component('dv5-my-stuff-tool-card',                 require('./components/dashboard-v5/my-stuff/MyStuffToolCard.vue'));
Vue.component('dv5-slide',                              require('./components/login-v5/sliders/Slide.vue'));
Vue.component('dv5-initial-slide',                      require('./components/dashboard-v5/auth/InitialSlide.vue'));
Vue.component('dv5-slide-component',                    require('./components/dashboard-v5/auth/SlideComponent.vue'));
Vue.component('tools-cards',                            require('./components/dashboard-v5/tool/ToolsCards.vue'));
Vue.component('CardBtn',                                require('./components/dashboard-v5/tutorial/components/CardBtn.vue'));
Vue.component('start-a-project2',                       require('./components/dashboard-v5/start-a-project/StartaProjectCard2.vue'));
Vue.component('new-info-modal',                         require('./components/dashboard-v5/info-modal/NewInfoModal.vue'));
Vue.component('dv5-bottom-banner',                      require('./components/dashboard-v5/banners/BottomBanner.vue'));
Vue.component('dv5-right-banner',                       require('./components/dashboard-v5/banners/RightBanner.vue'));
Vue.component('dv5-right-banner-card',                  require('./components/dashboard-v5/banners/RightBannerCard.vue'));
Vue.component('dv5-right-banner-vip',                   require('./components/dashboard-v5/banners/RightBannerVip.vue'));
Vue.component('dv5-right-special-banners',              require('./components/dashboard-v5/banners/RightSpecialBanners.vue'));
Vue.component('dv5-multiselect',                        require('./components/dashboard-v5/lib/dv5-multiselect.vue'));
Vue.component('modal-multiselect',                      require('./components/dashboard-v5/lib/ModalMultiselect.vue'));

//login v5
Vue.component('lv5-main',                           require('./components/login-v5/index.vue'));
Vue.component('lv6-main',                           require('./components/office-v6/auth/index.vue'));
Vue.component('lv5-form',                           require('./components/login-v5/forms/login.vue'));
Vue.component('lv5-form-new',                       require('./components/login-v5/forms/login_new.vue'));
Vue.component('lv5-fp-form',                        require('./components/login-v5/forms/forgotPassword.vue'));
Vue.component('lv5-cp-form',                        require('./components/login-v5/forms/changePassword.vue'));
Vue.component('lv5-circle-spinner',                 require('./components/login-v5/spinners/CircleSpinner.vue'));

/**
 * Components with Libraryes
 * */
Vue.component('multiselect',                        require("vue-multiselect"));
Vue.component("VueSlickCarousel",                   require("vue-slick-carousel"));
Vue.component("SpringSpinner",                      require("epic-spinners"));

//onboarding v5
Vue.component('onboarding-v5',                      require('./components/dashboard-v5/onboarding/onboarding-v5.vue'));
Vue.component('social-component',                   require('./components/dashboard-v5/onboarding/SocialComponent'));
Vue.component('dv5-collapse-onboarding',            require('./components/dashboard-v5/shared/CollapseOnboarding'));

//upgrade V5
Vue.component('dv5-upgrade',                        require('./components/dashboard-v5/upgrade/index'));

//Modal Chose Your Country
Vue.component('subsidiary-modal-v5',                require('./components/dashboard-v5/modal/SubsidiaryModalV5.vue'));

Vue.component('upgrade-funnel-club',                require('./components/dashboard-v5/modal/UpgradeFunnelClub.vue'));
Vue.component('new-support-alert',                  require('./components/dashboard-v5/modal/NewSupportAlert.vue'));
Vue.component('congratulations-funnel-club',        require('./components/dashboard-v5/modal/CongratulationsFunnelClub.vue'));
Vue.component('congatulations-wordpress-pro',       require('./components/dashboard-v5/modal/CongratulationsWordPressPro.vue'));

/**
 * User Reset Password modal
 * */
Vue.component('change-password',    require('./components/user/changeUserPassword'));

/**
 * Storage component
 * */
Vue.component('user-storage',       require('./components/user/userStorage'));

/**
 * Franchise
 * */
//Franchise old components (Used current)
Vue.component('start-here-v4',                       require('./components/franchise_v4/start/index/index.vue'));
Vue.component('autoresponder-v4',                    require('./components/franchise_v4/share/autoresponder/index.vue'));
Vue.component('ba-franchise-index-v4',               require('./components/franchise_v4/rank/index'));
Vue.component('header-page-v4',                      require('./components/franchise_v4/rank/components/header'));
Vue.component('affiliates-show-case-v4',             require('./components/franchise_v4/rank/components/affiliatesShowCase'));
Vue.component('graphic-disclosures-v4',              require('./components/franchise_v4/rank/components/graphicDisclosures'));
Vue.component('all-values-user-v4',                  require('./components/franchise_v4/rank/components/allValuesUser'));
Vue.component('all-values-user-br-v4',               require('./components/franchise_v4/rank/components/allValuesUserBR'));
Vue.component('car-bonus-v4',                        require('./components/franchise_v4/rank/components/carBonus'));
Vue.component('mansion-bonus-v4',                    require('./components/franchise_v4/rank/components/mansionBonus'));
Vue.component('level-info-v4',                       require('./components/franchise_v4/rank/components/levelInfo'));
Vue.component('radial-progress-v4',                  require('./components/franchise_v4/rank/components/radialProgress'));
Vue.component('social-v4',                           require('./components/franchise_v4/rank/components/social'));
Vue.component('links-user-v4',                       require('./components/franchise_v4/rank/components/linksUser'));
Vue.component('info-leads-v4',                       require('./components/franchise_v4/rank/components/infoLeads'));
Vue.component('current-earnings-v4',                 require('./components/franchise_v4/rank/components/currentEarnings'));
Vue.component('affiliate-link-v4',                   require('./components/franchise_v4/rank/components/affiliateLink'));
Vue.component('retention-bonus-v4',                  require('./components/franchise_v4/rank/components/retentionBonus'));
Vue.component('header-earnings-v4',                  require('./components/franchise_v4/rank/components/headerEarnings'));
Vue.component('affiliate-link-franchisee-plan-v4',   require('./components/franchise_v4/rank/components/linkUserFranchisee'));

Vue.component('lifestyle-bonus-v5',                  require('./components/franchise_v4/rank/components/lifeStyleBonus'));
Vue.component('earnings-forecast',                   require('./components/franchise_v4/rank/components/earningsForecast'));
Vue.component('activate-crm',                        require('./components/franchise_v4/rank/components/activateCRM'));
Vue.component('normal-link-user',                    require('./components/franchise_v4/rank/components/normalLinkUser'));
//franchise system v5
// affiliate dashboard v5
Vue.component('ba-franchise-index-v5',              require('./components/franchise_v5/affiliate_dashboard/index.vue'));
Vue.component('fs5-dashboard-tutorial',             require('./components/franchise_v5/affiliate_dashboard/dashboard_tutorial/index.vue'));
Vue.component('fs5-estimated-earns',                require('./components/franchise_v5/affiliate_dashboard/estimated_earns/index.vue'));
Vue.component('fs5-quick-links',                    require('./components/franchise_v5/affiliate_dashboard/quick_links/index.vue'));
Vue.component('fs5-link-generator',                 require('./components/franchise_v5/affiliate_dashboard/link_generator/index.vue'));
Vue.component('fs5-funnel-club',                    require('./components/franchise_v5/affiliate_dashboard/funnel_club/index.vue'));
Vue.component('fs5-earnings',                       require('./components/franchise_v5/affiliate_dashboard/earnings/index.vue'));
Vue.component('fs5-current-earnings',               require('./components/franchise_v5/affiliate_dashboard/current_earnings/index.vue'));
Vue.component('fs5-disclosure',                     require('./components/franchise_v5/affiliate_dashboard/disclosure/index.vue'));
Vue.component('fs5-affiliate-profile',              require('./components/franchise_v5/affiliate_dashboard/setup_affiliate_profile/index.vue'));
Vue.component('radial-progress-v3',                 require('./components/franchise_v3/components/radialProgress'));
Vue.component('associate-tokens',                   require('./components/franchise_v5/affiliate_dashboard/associate-tokens/index.vue'));

/*
* TODO @Mvoikolesco remover esse grupo abaixo
* componentes usado apeanas no antigo get paid
 */
// get paid v5
Vue.component('fs5-get-paid-index',              	  require('./components/franchise_v5/get_paid/user/index.vue'));
Vue.component('fs5-request-payments',              	require('./components/franchise_v5/get_paid/user/request_payments/index.vue'));
Vue.component('fs5-table-clients',              	  require('./components/franchise_v5/get_paid/user/table_clients/index.vue'));
Vue.component('fs5-earnings-notice',                require('./components/franchise_v5/get_paid/user/notice/index.vue'));
Vue.component('fs5-cards-status-payments',          require('./components/franchise_v5/get_paid/user/card_status_payments/index.vue'));

// Get Paid Used Components
Vue.component('fs5-view-rank-details',              require('./components/franchise_v5/get_paid/user/view_rank_details/index.vue'));
Vue.component('fs5-get-paid-tutorial',              require('./components/franchise_v5/get_paid/user/tutorial/index.vue'));
Vue.component('fs5-get-paid-collapse',              require('./components/franchise_v5/get_paid/user/collapse_tutorial/index.vue'));

// instant comissions v5
Vue.component('fs5-instant-commissions',            require('./components/franchise_v5/instant_commissions/index.vue'));

// code of ethics v5
Vue.component('fs5-code-of-ethics',                 require('./components/franchise_v5/code_of_ethics/index.vue'));

// notice board
Vue.component('fs5-notice-board',                   require('./components/franchise_v5/notice_board/index.vue'));
Vue.component('fs5-notice-card-v5',                 require('./components/franchise_v5/notice_board/notice_card.vue'));

// component info v5
Vue.component('fs5-collapse-info',                  require('./components/franchise_v5/tools/collapse_info/index.vue'));
Vue.component('fs5-input-copy',                     require('./components/franchise_v5/tools/input_copy/index.vue'));

// sidebar v5
Vue.component('fs5-sidebar',                        require('./components/franchise_v5/sidebar/index.vue'));

// switch button
Vue.component('switch-button',                      require('./components/franchise_v5/tools/switch/index.vue'));

// franchise message v5
Vue.component('fs5-franchise-message',              require('./components/franchise_v5/franchise_message/index.vue'));

//franchise system v5 tools
Vue.component('fs5-shared-collapse',                require('./components/franchise_v5/tools/collapse/Collapse.vue'));
Vue.component('fs5-button',                         require('./components/franchise_v5/tools/button/Button.vue'));
Vue.component('fs5-estimated-earns-card',           require('./components/franchise_v5/tools/card/EstimatedEarnsCard.vue'));
Vue.component('fs5-earnings-card',                  require('./components/franchise_v5/tools/card/EarningsCard.vue'));
Vue.component('fs5-current-earnings-card',          require('./components/franchise_v5/tools/card/CurrentEarningsCard.vue'));
Vue.component('fs5-section-header',                 require('./components/franchise_v5/tools/section_header/SectionHeader.vue'));

Vue.component('timezoneSelect',                     require('./components/dashboard-v5/lib/timezoneSelect'));

Vue.component('delete-account-new',                 require('./components/dashboard-v5/delete-account/index'));
Vue.component('card-delete',                        require('./components/dashboard-v5/delete-account/components/card-delete'));
Vue.component('btn-delete',                         require('./components/dashboard-v5/delete-account/components/btn-delete'));
Vue.component('lead-carousel',                      require('./components/dashboard-v5/delete-account/components/lead-carousel'));

//login wl -JTFoxx
Vue.component('wl-index',                          require('./components/wl-auth/index.vue'));
Vue.component('wl-form',                           require('./components/wl-auth/forms/login.vue'));
Vue.component('wl-fp-form',                        require('./components/wl-auth/forms/forgotPassword.vue'));
Vue.component('wl-cp-form',                        require('./components/wl-auth/forms/changePassword.vue'));
//Vue.component('wl-circle-spinner',                 require('./components/wl-auth/spinners/CircleSpinner.vue'));
Vue.component('user-edit-index',                   require('./components/user-edit/index.vue'));

/**
 * Global Components
 * */
Vue.component('general-modal',                      require('./components/dashboard-v5/modal/GeneralModal'));
Vue.component('global-table',                       require('../../global/js/components/global-table/GlobalTable'));

/**
 * WL Cheetah Builder Pro
 * */
Vue.component('invoice-pay-5',    require('./components/dashboard-v5/invoice-pay/index'));

/**
 * Layouts
 * */
Vue.component('tools-layout-component', require('./layouts/ToolsLayoutComponent.vue'));
Vue.component('franchise-layout', require('./layouts/FranchiseLayout.vue'));

/**
 * Website Agency
 * */
Vue.component('website-agency', require('./components/website-agency/WebsiteAgnecy.vue'));

 /**
 * Team Access
 * */
Vue.component('team-access', require('./components/team-access/TeamAccess.vue'));
Vue.component('tools-modal', require('./components/team-access/ToolsModal.vue'));

/**
 * SEO Report
 * */
Vue.component('seo-report', require('./components/seo-report/SeoReport.vue'));

/**
 * Connect Domain
 * */
Vue.component('connect-domain', require('./components/connect-domain/index.vue'))

/**
 * Builderall 6.0
 * */

// Dashboard 6.0
Vue.component('ba6-domain-email-manager-card',  require('./components/office-v6/dashboard/domain-email-manager/DomainEmailManagerCard.vue'));
Vue.component('ba6-elearning-card',             require('./components/office-v6/dashboard/elearning/ElearningCard.vue'));
Vue.component('ba6-mailingboss-statistics',     require('./components/office-v6/dashboard/mailingboss/MailingbossStatistics.vue'));
Vue.component('ba6-website-builder-card',       require('./components/office-v6/dashboard/website-builder/WebsiteBuilderCard.vue'));
Vue.component('ba6-website-builder-statistics', require('./components/office-v6/dashboard/website-builder/WebsiteBuilderStatistics.vue'));
Vue.component('ba6-your-favorites-card',        require('./components/office-v6/dashboard/your-favorites/YourFavoritesCard.vue'));
Vue.component('ba6-banner-top',                 require('./components/office-v6/dashboard/banners/BannerTop.vue'));
Vue.component('twenty-four-retrospective',      require('./components/office-v6/dashboard/banners/components/TwentyFourRetrospective.vue'));
Vue.component('ba7-workshops',                  require('./components/office-v6/dashboard/funnels/index.vue'))
Vue.component('ba7-get-started',                require('./components/office-v6/dashboard/get-started/index.vue'))

// User Settings
Vue.component('ba6-account-settings',   require('./components/office-v6/account-settings/Index.vue'));
Vue.component('ba6-layout-settings',    require('./components/office-v6/account-settings/components/layoutSettings.vue'))
Vue.component('ba6-account-info',       require('./components/office-v6/account-settings/routes/AccountInfo.vue'))
Vue.component('ba6-security',           require('./components/office-v6/account-settings/routes/Security.vue'))
Vue.component('ba6-invoices',           require('./components/office-v6/account-settings/routes/Invoices.vue'))
Vue.component('ba6-quotas',             require('./components/office-v6/account-settings/routes/Quotas.vue'))
Vue.component('ba6-affiliation',        require('./components/office-v6/account-settings/routes/Affiliation.vue'))
Vue.component('ba6-mailingboss',        require('./components/office-v6/account-settings/routes/Mailingboss.vue'))
Vue.component('ba6-modal',              require('./components/office-v6/account-settings/components/ModalV6.vue'))
Vue.component('ba6-user-storage',       require('./components/office-v6/account-settings/components/UserStorage.vue'))
Vue.component('ba6-code-inputs',        require('./components/office-v6/account-settings/components/CodeInputs.vue'))

// Upgrade
Vue.component('ba6-upgrade', require('./components/office-v6/upgrade/Index.vue'));

/**
 * TODO @Mvoikolesco Remover essa parte do new onboarding e BA Nation que não foi finalizado e foi substituido pelo view no wrapper
 * */
// Onboarding
Vue.component('onboarding-v6',        require('./components/onboarding/index.vue'))
Vue.component('onboarding-modal',     require('./components/onboarding/components/modal.vue'))
Vue.component('onboarding-home',      require('./components/onboarding/home.vue'))
Vue.component('onboarding-stepper',   require('./components/onboarding/components/stepper.vue'))
Vue.component('ba-nation', require('./components/ba-nation/index.vue'))

// Pause Account
Vue.component('pause-modal',    require('./components/office-v6/pause-account/modal.vue'))
Vue.component('pause-body',     require('./components/office-v6/pause-account/body.vue'))

// Franchise System V6
Vue.component('franchise-index',          require('./components/office-v6/franchise-system/franchise-index.vue'))
Vue.component('franchise-earn',           require('./components/office-v6/franchise-system/earn/franchise-earn.vue'))
Vue.component('gains-franchisee-ba-v4',   require('./components/franchise_v4/rank/components/gainsFranchiseeBa'));

// Franchise Modals
Vue.component('autoresponder-v5', require('./components/franchise_v4/modals/Autoresponder.vue'))

// Franchise components
Vue.component('fs6-input-copy',                     require('./components/franchise_v5/tools/newinput_copy/index.vue'));

  // vue toastification for vue
  var toastDefaultOptions = {
    position: 'bottom-right',
    newestOnTop: false,
    maxToasts: 10,
    draggable: false,
    timeout: 5000,
    container: function () {
      return document.getElementById('toastr-v5-wrapper')
    },
    toastClassName: ['toastr-v5'], // 'toastr-v5-dark'
    icon: {
      iconClass: "toastr-icon",
      iconTag: 'div'
    },
  };
  Vue.use(Toast, toastDefaultOptions);

  window.getInnerComponent = function(message = ''){
    return {
      component: InnerHtnlToastV5,
      props: {
        message: message
      }
    }
  }

  Vue.use(Vuelidate);

  Vue.use(InfiniteLoading, { /* options */ });

// </ba-v5>


//</globals elements>
export const bus = new Vue();

if (document.getElementById('app')) {
  new Vue({
    el: '#app'
  });
}

if (document.getElementById('app-jt-foxx')) {
  new Vue({
    el: '#app-jt-foxx'
  });
}

if (document.getElementById('app-layout-jt-foxx')) {
  new Vue({
    el: '#app-layout-jt-foxx'
  });
}

if (document.getElementById('app-sidebar')) {
  new Vue({
    el: '#app-sidebar',
    mounted() {
      const conteudo = document.getElementById('content');
      const slotContent = document.getElementById('slot-content');
      const builderallLoader = document.getElementById('builderall-loader');

      if (conteudo && slotContent) {
        slotContent.appendChild(conteudo);
        builderallLoader.setAttribute('loading', 'false')
        builderallLoader.style.display = 'none'
      }
    }
  });
}

if (document.getElementById('app-layout')) {
  new Vue({
    el: '#app-layout'
  });
}

if (document.getElementById('app__2fa')) {
  new Vue({
    el: '#app__2fa'
  });
}

if (document.getElementById('app-modals')){
  new Vue({
    el: '#app-modals'
  });
}

if (document.getElementById('app-modals2')){
  new Vue({
    el: '#app-modals2'
  });
}

if (document.getElementById('app-subsidiaries')){
    new Vue({
        el: '#app-subsidiaries'
    });
}

if (document.getElementById('app-settings')){
  new Vue({
    el: '#app-settings'
  });
}




// WEBPACK FOOTER //
// ./resources/office/js/office.js